export default __webpack_public_path__ + "static/lsa-website-1-3fee4bb27c7a082b7fd5f0e1fc90bf45.jpg";